export default __webpack_public_path__ + "static/095-ccccb0a7c3e7828dd3867b8732f12d43.jpg";